import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import Star from '../components/Star';
import ParameterErrors from '../errors/ParameterErrors';
import IconButtonNonReact from '../components/IconButtonNonReact';
import PlotStatus from '../site/PlotStatus';
import AssetsManager from '../assets_management/AssetsManager';
import Urls from '../urls/Urls';
import UrlHelper from '../core/UrlHelper';
import ResizeWatcher from '../ui_core/ResizeWatcher';
import DynamicImageDisplayer from '../images/DynamicImageDisplayer';
import Once from '../core/Once';
import PlotDetailedInformationSectionType from './PlotDetailedInformationSectionType';
import eventEnable from '../core/eventEnable';
const {throwNotProvided}=ParameterErrors;
export default class PlotDetailedInformationGallery {
	constructor(props){
		const { siteJsonUnitPlot, showImagesFullScreen, configuration}=props;
		this._configuration = configuration;
		eventEnable(this);
		this._siteJsonUnitPlot = siteJsonUnitPlot;
		this._showImagesFullScreen = showImagesFullScreen;
		this._setupFromSiteJsonUnitPlot = this._setupFromSiteJsonUnitPlot.bind(this);
		this._element = document.createElement('div');
		this._element.classList.add('gallery');
		this._loadImages= this._loadImages.bind(this);
		this._resized = this._resized.bind(this);
		this._setRoomImageClass = this._setRoomImageClass.bind(this);
		this._dispatchLoaded = this._dispatchLoaded.bind(this);
		this._resizeWatcherParentElement = new ResizeWatcher({element:this._element});
		this._resizeWatcherParentElement.addEventListener('resized', this._resized);
		this._loadedOnce = new Once(this._dispatchLoaded);
		this._imgWrapperElement = document.createElement('div');
		this._imgWrapperElement.classList.add('room-image-wrapper');
		this._element.appendChild(this._imgWrapperElement);
		this._setupFromSiteJsonUnitPlot();
	}
	set plot(siteJsonUnitPlot){
		this._siteJsonUnitPlot = siteJsonUnitPlot;
		this._setupFromSiteJsonUnitPlot();
	}
	_setupFromSiteJsonUnitPlot(){
		setTimeout(this._loadImages, 0);
	}
	_resized(){
		const width = this._element.clientWidth;
		if(width<400){
			this._setRoomImageClass('room-images-one-per-row');
			return;
		}
		if(width<600){
			this._setRoomImageClass('room-images-two-per-row');
			return;
		}
		if(width<800){
			this._setRoomImageClass('room-images-three-per-row');
			return;
		}
		if(width<1000){
			this._setRoomImageClass('room-images-four-per-row');
			return;
		}
		this._setRoomImageClass('room-images-five-per-row');
		
	}
	_setRoomImageClass(newClassName){
		if(this._currentRoomImageClassName){
			this._element.classList.remove(this._currentRoomImageClassName);
		}
		this._currentRoomImageClassName = newClassName;
			this._element.classList.add(newClassName);
	}
	_loadImages(){
		this._element.innerHTML='';
		const frontViewImage = this._siteJsonUnitPlot.unit.frontViewImage;
		let dynamicImageDisplayer = new DynamicImageDisplayer({
			dynamicImage:frontViewImage, 
			parentElement:this._element, 
			resizeWatcherParentElement:this._resizeWatcherParentElement,
			className:'plot-image',
			fitWidthElseHeight:true,
			onClick:()=>this._showImagesFullScreen([this._siteJsonUnitPlot.unit.frontViewImage]),
			onLoaded:this._loadedOnce.trigger,
			configuration:this._configuration
		});
		const streetViewImage = this._siteJsonUnitPlot.unit.streetViewImage;
		if(streetViewImage&&(streetViewImage.entries[0].relativePath!==frontViewImage.entries[0].relativePath)){
			new DynamicImageDisplayer({
					dynamicImage:streetViewImage, 
					parentElement:this._element, 
					resizeWatcherParentElement:this._resizeWatcherParentElement,
					className:'plot-image',
					fitWidthElseHeight:true,
					onClick:()=>this._showImagesFullScreen([streetViewImage]),
					configuration:this._configuration
			});
		}
		
		if(!this._siteJsonUnitPlot.rooms)return;
		this._dynamicRoomImages = [];
		this._siteJsonUnitPlot.rooms.getArray().forEach((room)=>{
			this._dynamicRoomImages = this._dynamicRoomImages.concat(room.images);
		});
		this._imgWrapperElement.innerHTML='';
		this._dynamicRoomImages.forEach(dynamicImage=>{
			new DynamicImageDisplayer({
				dynamicImage, 
				parentElement: this._imgWrapperElement,
				resizeWatcherParentElement:this._resizeWatcherParentElement,
				className:'room-image',
				fitWidthElseHeight:false,
				onClick:()=>this._showImagesFullScreen([dynamicImage]),
				configuration:this._configuration
			});
		});
	}
	get element(){
		return this._element;
	}
	get sectionType(){
		return PlotDetailedInformationSectionType.Gallery;
	}
	_dispatchLoaded(){
		this.dispatchEvent({type:'loaded'});
	}
}